import init from '@/assets/init.png'
import initAct from '@/assets/initAct.png'
import paramSet from '@/assets/paramSet.png'
import paramSetAct from '@/assets/paramSetAct.png'
import customNo from '@/assets/customNo.png'
import customNoAct from '@/assets/customNoAct.png'
import goodsNo from '@/assets/goodsNo.png'
import goodsNoAct from '@/assets/goodsNoAct.png'
import buyCompany from '@/assets/buyCompany.png'
import buyCompanyAct from '@/assets/buyCompanyAct.png'
import carNo from '@/assets/carNo.png'
import carNoAct from '@/assets/carNoAct.png'
import taxNo from '@/assets/taxNo.png'
import taxNoAct from '@/assets/taxNoAct.png'

import invoiceInsert from '@/assets/invoiceInsert.png'
import invoiceInsertAct from '@/assets/invoiceInsertAct.png'
import invoiceDis from '@/assets/invoiceDis.png'
import invoiceDisAct from '@/assets/invoiceDisAct.png'
import invoiceBack from '@/assets/invoiceBack.png'
import invoiceBackAct from '@/assets/invoiceBackAct.png'
import stockQuery from '@/assets/stockQuery.png'
import stockQueryAct from '@/assets/stockQueryAct.png'
import onlineApply from '@/assets/onlineApply.png'
import onlineApplyAct from '@/assets/onlineApplyAct.png'
import onlineBuy from '@/assets/onlineBuy.png'
import onlineBuyAct from '@/assets/onlineBuyAct.png'
import onlineTicketing from '@/assets/onlineTicketing.png'
import onlineTicketingAct from '@/assets/onlineTicketingAct.png'

import invoiceSet from '@/assets/invoiceSet.png'
import invoiceSetAct from '@/assets/invoiceSetAct.png'
import invoiceWrite from '@/assets/invoiceWrite.png'
import invoiceWriteAct from '@/assets/invoiceWriteAct.png'
import invoiceQuery from '@/assets/invoiceQuery.png'
import invoiceQueryAct from '@/assets/invoiceQueryAct.png'
import invoiceRepaire from '@/assets/invoiceRepaire.png'
import invoiceRepaireAct from '@/assets/invoiceRepaireAct.png'
import invoiceVoid from '@/assets/invoiceVoid.png'
import invoiceVoidAct from '@/assets/invoiceVoidAct.png'
import infoSheet from '@/assets/infoSheet.png'
import infoSheetAct from '@/assets/infoSheetAct.png'

import sumInfoExport from '@/assets/sumInfoExport.png'
import sumInfoExportAct from '@/assets/sumInfoExportAct.png'
import remortCardClear from '@/assets/remortCardClear.png'
import remortCardClearAct from '@/assets/remortCardClearAct.png'
import sumUpload from '@/assets/sumUpload.png'
import sumUploadAct from '@/assets/sumUploadAct.png'
import statusQuery from '@/assets/statusQuery.png'
import statusQueryAct from '@/assets/statusQueryAct.png'
import staticsSum from '@/assets/staticsSum.png'
import staticsSumAct from '@/assets/staticsSumAct.png'
import printing from '@/assets/printing.png'
import printingAct from '@/assets/printingAct.png'
import invoiceExport from '@/assets/invoiceExport.png'
import invoiceExportAct from '@/assets/invoiceExportAct.png'

import backup from '@/assets/backup.png'
import backupAct from '@/assets/backupAct.png'
import dataMigration from '@/assets/dataMigration.png'
import dataMigrationAct from '@/assets/dataMigrationAct.png'
import goldOnlineChange from '@/assets/goldOnlineChange.png'
import goldOnlineChangeAct from '@/assets/goldOnlineChangeAct.png'
import taxOnlineChange from '@/assets/taxOnlineChange.png'
import taxOnlineChangeAct from '@/assets/taxOnlineChangeAct.png'

import toLeft from '@/assets/toLeft.png'
import toRight from '@/assets/toRight.png'
import toUpRight from '@/assets/toUpRight.png'
import toDownRight from '@/assets/toDownRight.png'
import toDown from '@/assets/toDown.png'
import toUp from '@/assets/toUp.png'

import invoicePt from '@/assets/invoice-pt.png'
import invoiceZy from '@/assets/invoice-zy.png'
import invoiceDz from '@/assets/invoice-dzpt.png'

export const dynamicImg = {
  init,
  initAct,
  paramSet,
  paramSetAct,
  customNo,
  customNoAct,
  goodsNo,
  goodsNoAct,
  buyCompany,
  buyCompanyAct,
  carNo,
  carNoAct,
  taxNo,
  taxNoAct,

  // 票源管理
  invoiceInsert,
  invoiceInsertAct,
  invoiceDis,
  invoiceDisAct,
  invoiceBack,
  invoiceBackAct,
  stockQuery,
  stockQueryAct,
  onlineApply,
  onlineApplyAct,
  onlineBuy,
  onlineBuyAct,
  onlineTicketing,
  onlineTicketingAct,

  // 发票管理
  invoiceSet,
  invoiceSetAct,
  invoiceWrite,
  invoiceWriteAct,
  invoiceQuery,
  invoiceQueryAct,
  invoiceRepaire,
  invoiceRepaireAct,
  invoiceVoid,
  invoiceVoidAct,
  infoSheet,
  infoSheetAct,

  // 汇总处理
  sumInfoExport,
  sumInfoExportAct,
  remortCardClear,
  remortCardClearAct,
  sumUpload,
  sumUploadAct,
  statusQuery,
  statusQueryAct,
  staticsSum,
  staticsSumAct,
  printing,
  printingAct,
  invoiceExport,
  invoiceExportAct,

  // 系统维护
  backup,
  backupAct,
  dataMigration,
  dataMigrationAct,
  goldOnlineChange,
  goldOnlineChangeAct,
  taxOnlineChange,
  taxOnlineChangeAct,

  toLeft,
  toRight,
  toUpRight,
  toDownRight,
  toDown,
  toUp,

  invoicePt,
  invoiceZy,
  invoiceDz,
}
